// import { IText } from "fabric/fabric-impl";
import React from "react";

class ListView extends React.Component {

    state = {
        pje: [
            {
                name: 'Reading Book',
                time: '10 : 30 pm',
            },
            {
                name: 'Attend a business meeting ...',
                time: '10 : 30 am',
            },
            {
                name: 'Reading Book',
                time: '10 : 30 pm',
            },
            {
                name: 'Attend a business meeting ...',
                time: '10 : 30 am',
            },
            {
                name: 'Reading Book',
                time: '10 : 30 pm',
            },
            {
                name: 'Attend a business meeting ...',
                time: '10 : 30 am',
            },

        ]
    }


    componentDidMount() {
        // this.init()
        this.main.addEventListener('wheel', this.onWheel, true)
    }


    componentWillUnmount() {
        this.main.removeEventListener('wheel', this.onWheel)

    }


    onWheel = (e) => {
        // console.log(e)
        e.stopPropagation()
    }


    render() {
        return (

            <div className="dashboard-widgets">
                <div style={{ background: '#fff', borderRadius: '15px 15px 0 0', }} className="d-flex justify-content-between align-items-center p-3">
                    <div className="d-flex flex-column">
                        <div>

                            <p>Today Tasks</p>
                        </div>
                        <div>

                            <p style={{ color: '#A7A7A7', fontSize: 12 }}>21 June 2021 , 09:38 pm</p>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        <div><img src="/images/icons/add.png" width={'20px'} /></div>
                        <div className="d-flex pld-1 pb-2">

                            <p style={{ fontWeight: '700' }}>12</p>&nbsp;<p style={{ color: '#D2D2D2', fontWeight: '700' }}>/ 15</p>
                        </div>
                    </div>
                </div>
                <div ref={el => this.main = el} className='box-shadow-widgets' style={{ minHeight: 300, height: '100%', maxHeight: '400px', overflow: 'auto' }}>

                    <div className="mb-3  " style={{ margin: ' 0 5% ' }}>
                        <div className="" style={{}}>
                            {this.state.pje.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <div className="d-flex justify-content-between align-items-center " style={{ padding: '3% 0' }}>
                                            <div className="d-flex align-items-center">
                                                <div className="mrd-2">
                                                    <div style={{ width: 15, height: 15, borderRadius: 100, background: '#F4F5F8' }} />
                                                </div>
                                                <p style={{ fontSize: 15, color: '#A7A7A7' }}>
                                                    {item.name}
                                                </p>
                                            </div>
                                            <div>
                                                <p style={{ fontSize: 12, color: '#A7A7A7' }}>
                                                    {item.time}
                                                </p>
                                            </div>
                                        </div>
                                        <div style={{ borderBottom: '1px solid #ebeaf2' }} />
                                    </div>
                                )
                            })}
                        </div>
                    </div>


                </div>
            </div>

        )
    }
}


export default ListView;